import api from "../services/api";
import _ from "lodash";
import moment from "moment";

const dataConvert = (response, orgList, type) => {
  const orgMap = _.keyBy(orgList, 'id');
  return response.map(i => ({
    ...i,
    entity_id: type === 'org' ? i.organizationId : orgMap[i.organizationId].businessGroupId,
  }));
}

// eslint-disable-next-line complexity
const parseByMonth = (data, rowList) => {
  let headerCol = [];
  const currYear = moment().year();
  const lastYear = currYear - 1;
  const indexDate = moment().startOf('month');
  const currentYearMonths = indexDate.month();
  const prevYearLoopCount = currentYearMonths < 6 ? 8 - currentYearMonths: 0;

  for (let i= currentYearMonths; i>=0; i--) {
    headerCol.push({ value: indexDate.format('L'), text: indexDate.format('MMM')});
    indexDate.subtract(1,'month');
  }
  headerCol.push({ value:`total${currYear}`, text:`Total ${currYear}` });

  for (let i= prevYearLoopCount; i>0; i--) {
    headerCol.push({ value: indexDate.format('L'), text: indexDate.format('MMM YY')});
    indexDate.subtract(1,'month');
  }
  headerCol.push({ value:`total${lastYear}`, text:`Total ${lastYear}` })


  const headerSet = new Set(headerCol.map(i => i.value));
  const res = _.map(rowList, (rowParent, k) => {
    const serverDataForId = data.filter(r => r.entity_id === rowParent.id)

    const row = {}
    headerCol.forEach((column) => {
      row[column.value] = 0
    })
    row['name'] = rowParent.name
    row['id'] = rowParent.id

    serverDataForId.forEach((j) => {
      const date = moment(j.date).utc();
      const year = +date.format('YYYY');
      const columnName = date.format('L');

      if (headerSet.has(columnName)) {
          row[columnName] += j.totalAmount
      }
      row[`total${year}`] += j.totalAmount
    })

    return row;
  })

  return {data: res, col: headerCol}
};

const parseByQ = (data, rowList) => {

  let headerCol = [];
  const currYear = moment().year();
  const lastYear = currYear - 1;

  for (let i = moment().quarter(); i > 0; i--) {
    headerCol.push({ value: `q_${i}_${currYear}`, text: `q ${i} ${currYear}`});
  }
  headerCol.push({ value:`total${currYear}`, text:`Total ${currYear}` });

  for (let i =4; i > 0; i--) {
    headerCol.push({ value: `q_${i}_${lastYear}`, text: `q ${i} ${lastYear}`});
  }
  headerCol.push({ value:`total${lastYear}`, text:`Total ${lastYear}` })

  const res = _.map(rowList, (rowParent, k) => {
    const serverDataForId = data.filter(r => r.entity_id === rowParent.id)

    const row = {}
    headerCol.forEach((column) => {
      row[column.value] = 0
    })
    row['name'] = rowParent.name
    row['id'] = rowParent.id

    serverDataForId.forEach((j) => {
      const year = +moment(j.date).utc().format('YYYY');
      const q = moment(j.date).utc().quarter();
      row[`q_${q}_${year}`] += j.totalAmount
      row[`total${year}`] += j.totalAmount
    })

    return row;
  })

  return {data: res, col: headerCol}
};

const  organizationProductConvert = (data, rowList , groupedPropName) => {

    const res = _.map(rowList, (rowParent, k) => {
      const serverDataForId = data.filter(r => r[groupedPropName] === rowParent.id)

      const row = {
        organizationIds: new Set(),
        entityId: rowParent.id,
        amount: 0,
        vtAmount: 0,
        ptAmount: 0,
        lcAmount: 0,
        liAmount: 0,
        inquiriesCount: 0,
        billingInfoIds: new Set(),
      };

      serverDataForId.forEach((j) => {
        row.organizationIds.add(j.organizationId);
        row.amount+=j.totalAmount;
        row.billingInfoIds.add(j.billingInfoId);

        // eslint-disable-next-line complexity
        j.billingReportDetails.forEach(d => {
          switch (d.product) {
            case 'VarianceTable': { row.vtAmount += d.amount; break;}
            case 'PricingTool': { row.ptAmount += d.amount; break;}
            case 'LucidComm': { row.lcAmount += d.amount; break;}
            case 'LucidInsights': { row.liAmount += d.amount; break;}
          }
          row.inquiriesCount += d.totalCount-d.errorCount;
        });
      })

      return row;
    })
    return {data: res}
}

export default {
  actions: {
    async orgByMonth({commit}, { type, rowFilter, dataFilter }) {
      const { orgFilter, bgFilter } = rowFilter;
      const orgList = await this.dispatch(`organizations/getOrganizations`, orgFilter)
      const bgList = await this.dispatch(`businessGroups/getBusinessGroups`, bgFilter)

      const response = await api.orgByMonth(dataFilter);
      const data = dataConvert(response, orgList.raw, type);
      const isOrgGrouping = type === 'org'
      return parseByMonth(data,isOrgGrouping ? orgList.raw: bgList)
    },
    async orgByQt({commit}, { type, rowFilter, dataFilter }) {
      const { orgFilter, bgFilter } = rowFilter;
      const orgList = await this.dispatch(`organizations/getOrganizations`, orgFilter)
      const bgList = await this.dispatch(`businessGroups/getBusinessGroups`, bgFilter)

      const response = await api.orgByMonth(dataFilter);
      const data = dataConvert(response, orgList.raw, type);
      const isOrgGrouping = type === 'org'
      return parseByQ(data, isOrgGrouping ? orgList.raw: bgList);
    },

    async productRevenue({commit}, { type, rowFilter, dataFilter }) {
      const { orgFilter, bgFilter } = rowFilter;
      const orgList = await this.dispatch(`organizations/getOrganizations`, orgFilter)
      const bgList = await this.dispatch(`businessGroups/getBusinessGroups`, bgFilter)

      const data = await api.productRevenue(dataFilter);
      const isOrgGrouping = type === 'org'
      return organizationProductConvert(data,
        isOrgGrouping ? orgList.raw: bgList,
        isOrgGrouping ? 'organizationId': 'businessGroupId');
    },
  },
  namespaced: true,
};
